/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';

import React, { PureComponent } from 'react';
import * as renderers from './CircleWidget_renderers';

// Styles
import './styles/CircleWidget.scss';

const propTypes = {
  label: PropTypes.string,
  circleType: PropTypes.string.isRequired,
  circleData: PropTypes.object.isRequired,
};

class CircleWidget extends PureComponent {
  /* eslint-disable */
  componentDidMount() {
    // Init jquery circle widgets
    $('.circle-fillable').each((index, element) => {
      $(element).circleProgress({
        value: $(element).data('percentage') / 100,
        startAngle: Math.PI * 1.5,
        size: 240,
        thickness: 30,
        animation: {
          duration: 4000,
        },
        fill: {
          color: 'hsl(24, 88%, 55%)',
        },
      });
    });
  }
  /* eslint-enable */

  renderCircleInnerContent(ctype, cdata, label) {
    let circleInnerContent;
    if (ctype === 'personnel') {
      circleInnerContent = renderers.renderPersonnelCircle(cdata, label);
    } else if (ctype === 'age_in_days') {
      circleInnerContent = renderers.renderAgeCircle(cdata, label);
    } else if (ctype === 'turnover') {
      circleInnerContent = renderers.renderTurnoverCircle(cdata, label);
    } else if (ctype === 'vat') {
      circleInnerContent = renderers.renderVatCircle(cdata);
    } else if (ctype === 'employer') {
      circleInnerContent = renderers.renderEmployerCircle(cdata);
    } else if (ctype === 'tax_prepayment') {
      circleInnerContent = renderers.renderTaxPrepaymentCircle(cdata);
    } else if (ctype === 'accident') {
      circleInnerContent = renderers.renderAccidentCircle(cdata);
    } else if (ctype === 'liability') {
      circleInnerContent = renderers.renderLiabilityCircle(cdata);
    } else if (ctype === 'electrical_installation') {
      circleInnerContent = renderers.renderElectricalInstallationCircle();
    }

    return circleInnerContent;
  }

  render() {
    const { circleData, circleType, label } = this.props;
    return (
      <div styleName="CircleWidget">
        {this.renderCircleInnerContent(circleType, circleData, label)}
      </div>
    );
  }
}

CircleWidget.propTypes = propTypes;

export default CircleWidget;
